/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Contact_TitleInputs */

const es_privacy_policy_contact_title = /** @type {(inputs: Privacy_Policy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Contacto`)
};

const en_privacy_policy_contact_title = /** @type {(inputs: Privacy_Policy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Contact`)
};

/**
* | output |
* | --- |
* | "11. Contact" |
*
* @param {Privacy_Policy_Contact_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_contact_title = /** @type {((inputs?: Privacy_Policy_Contact_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Contact_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_contact_title(inputs)
	return en_privacy_policy_contact_title(inputs)
});
export { privacy_policy_contact_title as "privacy_policy.contact.title" }